module.exports = __webpack_public_path__ + "img/IG_mexico.70abc28c.jpg";